/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const rentSizeAvailability = /* GraphQL */ `
  query RentSizeAvailability(
    $appInstance: String!
    $mobVersion: Int!
    $pointSellId: String!
    $productId: String!
    $dateFrom: AWSDateTime!
    $dateTo: AWSDateTime!
  ) {
    rentSizeAvailability(
      appInstance: $appInstance
      mobVersion: $mobVersion
      pointSellId: $pointSellId
      productId: $productId
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      appInstance
      mobVersion
      productId
      size
      sizeUnit
      articleCountTotalSum
      orderNumber
      __typename
    }
  }
`;
export const rentArticleAvailability = /* GraphQL */ `
  query RentArticleAvailability(
    $appInstance: String!
    $mobVersion: Int!
    $pointSellId: String!
    $productId: String!
    $dateFrom: AWSDateTime!
    $dateTo: AWSDateTime!
    $size: String
  ) {
    rentArticleAvailability(
      appInstance: $appInstance
      mobVersion: $mobVersion
      pointSellId: $pointSellId
      productId: $productId
      dateFrom: $dateFrom
      dateTo: $dateTo
      size: $size
    ) {
      mssId
      appInstance
      articleType
      productId
      locationId
      pointSellId
      title
      description
      articleCountTotal
      size
      sizeUnit
      __typename
    }
  }
`;
export const schoolListVariants = /* GraphQL */ `
  query SchoolListVariants(
    $appInstance: String!
    $mobVersion: Int!
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
    $locationMssId: Int!
    $pointMeetingMssId: Int!
    $skillMssId: Int!
    $languageCodes: [String]
    $requestedLengthTotal: Int!
    $requestedLengthAvg: Int!
    $candidateSlots: [CandidateSlotIn]!
  ) {
    schoolListVariants(
      appInstance: $appInstance
      mobVersion: $mobVersion
      dateFrom: $dateFrom
      dateTo: $dateTo
      locationMssId: $locationMssId
      pointMeetingMssId: $pointMeetingMssId
      skillMssId: $skillMssId
      languageCodes: $languageCodes
      requestedLengthTotal: $requestedLengthTotal
      requestedLengthAvg: $requestedLengthAvg
      candidateSlots: $candidateSlots
    )
  }
`;
export const schoolListFreeSlots = /* GraphQL */ `
  query SchoolListFreeSlots(
    $appInstance: String!
    $mobVersion: Int!
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
    $variantIds: [Int!]!
    $candidateSlots: [CandidateSlotIn]!
    $pointMeetingMssId: Int!
  ) {
    schoolListFreeSlots(
      appInstance: $appInstance
      mobVersion: $mobVersion
      dateFrom: $dateFrom
      dateTo: $dateTo
      variantIds: $variantIds
      candidateSlots: $candidateSlots
      pointMeetingMssId: $pointMeetingMssId
    ) {
      timeFrom
      timeTo
      subjectMssId
      sganttWorkDayMssId
      __typename
    }
  }
`;
export const schoolListVariantsV2 = /* GraphQL */ `
  query SchoolListVariantsV2(
    $appInstance: String!
    $mobVersion: Int!
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
    $locationMssId: Int!
    $pointMeetingMssId: Int!
    $skillMssId: Int!
    $skillLevelClientMssId: Int
    $ageGroupMssIds: [Int]
    $languageCodes: [String]
    $requestedLengthTotal: Int!
    $requestedLengthAvg: Int!
    $candidateSlots: [CandidateSlotIn]!
  ) {
    schoolListVariantsV2(
      appInstance: $appInstance
      mobVersion: $mobVersion
      dateFrom: $dateFrom
      dateTo: $dateTo
      locationMssId: $locationMssId
      pointMeetingMssId: $pointMeetingMssId
      skillMssId: $skillMssId
      skillLevelClientMssId: $skillLevelClientMssId
      ageGroupMssIds: $ageGroupMssIds
      languageCodes: $languageCodes
      requestedLengthTotal: $requestedLengthTotal
      requestedLengthAvg: $requestedLengthAvg
      candidateSlots: $candidateSlots
    )
  }
`;
export const schoolListFreeSlotsV2 = /* GraphQL */ `
  query SchoolListFreeSlotsV2(
    $appInstance: String!
    $mobVersion: Int!
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
    $variantIds: [Int!]!
    $candidateSlots: [CandidateSlotIn]!
    $pointMeetingMssId: Int!
  ) {
    schoolListFreeSlotsV2(
      appInstance: $appInstance
      mobVersion: $mobVersion
      dateFrom: $dateFrom
      dateTo: $dateTo
      variantIds: $variantIds
      candidateSlots: $candidateSlots
      pointMeetingMssId: $pointMeetingMssId
    ) {
      timeFrom
      timeTo
      subjectMssId
      sganttWorkDayMssId
      __typename
    }
  }
`;
export const schoolListGroupCourse = /* GraphQL */ `
  query SchoolListGroupCourse(
    $appInstance: String!
    $mobVersion: Int!
    $productMssId: Int!
    $locationMssId: Int!
    $skillLevelClientMssId: Int
    $languageCodes: [String]
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
  ) {
    schoolListGroupCourse(
      appInstance: $appInstance
      mobVersion: $mobVersion
      productMssId: $productMssId
      locationMssId: $locationMssId
      skillLevelClientMssId: $skillLevelClientMssId
      languageCodes: $languageCodes
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      id
      mobVersion
      appInstance
      mssId
      title
      description
      pointMeetingMssId
      dateFrom
      dateTo
      availableCapacity
      hoursPerDay
      minLength
      skillLevelClientId
      allowGroupCourseFlexibleStart
      price
      __typename
    }
  }
`;
export const getGroupCourseByMssId = /* GraphQL */ `
  query GetGroupCourseByMssId(
    $appInstance: String!
    $mobVersion: Int!
    $productMssId: Int!
    $groupCourseMssId: Int!
  ) {
    getGroupCourseByMssId(
      appInstance: $appInstance
      mobVersion: $mobVersion
      productMssId: $productMssId
      groupCourseMssId: $groupCourseMssId
    ) {
      id
      mobVersion
      appInstance
      mssId
      title
      description
      pointMeetingMssId
      dateFrom
      dateTo
      availableCapacity
      hoursPerDay
      minLength
      skillLevelClientId
      allowGroupCourseFlexibleStart
      price
      __typename
    }
  }
`;
export const schoolListGroupCourseLesson = /* GraphQL */ `
  query SchoolListGroupCourseLesson(
    $appInstance: String!
    $mobVersion: Int!
    $groupCourseMssId: Int!
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
  ) {
    schoolListGroupCourseLesson(
      appInstance: $appInstance
      mobVersion: $mobVersion
      groupCourseMssId: $groupCourseMssId
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      id
      mobVersion
      appInstance
      mssId
      timeFrom
      timeTo
      availableCapacity
      __typename
    }
  }
`;
export const getRentProductRequirement = /* GraphQL */ `
  query GetRentProductRequirement($id: ID!) {
    getRentProductRequirement(id: $id) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRentProductRequirements = /* GraphQL */ `
  query ListRentProductRequirements(
    $filter: ModelRentProductRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentProductRequirements(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        rentProductType
        nameDisplayed
        nameRequired
        sexDisplayed
        sexRequired
        ageDisplayed
        ageRequired
        weightDisplayed
        weightRequired
        heightDisplayed
        heightRequired
        shoeSizeDisplayed
        shoeSizeRequired
        rentAbilityLevelDisplayed
        rentAbilityLevelRequired
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRentProductRequirementByAppInstance = /* GraphQL */ `
  query ListRentProductRequirementByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRentProductRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentProductRequirementByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        rentProductType
        nameDisplayed
        nameRequired
        sexDisplayed
        sexRequired
        ageDisplayed
        ageRequired
        weightDisplayed
        weightRequired
        heightDisplayed
        heightRequired
        shoeSizeDisplayed
        shoeSizeRequired
        rentAbilityLevelDisplayed
        rentAbilityLevelRequired
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgeGroup = /* GraphQL */ `
  query GetAgeGroup($id: ID!) {
    getAgeGroup(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      ageFrom
      ageTo
      createdAt
      updatedAt
      products {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listAgeGroups = /* GraphQL */ `
  query ListAgeGroups(
    $filter: ModelAgeGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgeGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        ageFrom
        ageTo
        createdAt
        updatedAt
        products {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgeGroupsByAppInstance = /* GraphQL */ `
  query ListAgeGroupsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgeGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgeGroupsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        ageFrom
        ageTo
        createdAt
        updatedAt
        products {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMOBConfig = /* GraphQL */ `
  query GetMOBConfig($id: ID!) {
    getMOBConfig(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mobDeploymentId
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      schoolGroupBookingOffset
      schoolCampBookingOffset
      rentBookingOffsetHours
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      introText
      emailText
      emailTextSchool
      emailTextRent
      lowSeasons {
        from
        to
        __typename
      }
      discountCodeImplementation
      generalTermsConditionsURL
      rentalSetsEnabled
      rentalDisplaySizesEnabled
      displayGeneralPrices
      displayPickUpDate
      schoolPointMeetingInfo
      schoolPointMeetingUrl
      schoolSkillLevelClientInfo
      schoolSkillLevelClientURL
      sganttSlotTimeLengthReductions {
        sganttSlotType
        defaultReduction
        reductions {
          timeLengthInHours
          reductionInMinutes
          __typename
        }
        __typename
      }
      mobRentIcon
      mobSchoolIcon
      locales
      defaultLocale
      courseLanguages
      courseGroupClientLanguages
      coursePrivateClientLanguages
      courseGroupIsWholeDayRequired
      rentSelectSizeAutomatic
      shoeSizeItems
      rentDisabledPointSells
      rentDatePickTryOutEnabled
      deliveryPoints
      rentProductCardImgHeightXs
      rentProductCardImgHeightSm
      rentProductCardImgHeightMd
      rentProductCardImgHeightLg
      rentProductCardImgHeightXl
      rentSearchSmCols
      rentSearchMdCols
      rentSearchLgCols
      rentProductCardImgAspectRatio
      useV2SchoolAvailability
      gaTrackingId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMOBConfigs = /* GraphQL */ `
  query ListMOBConfigs(
    $filter: ModelMOBConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMOBConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mobDeploymentId
        enabled
        enabledSchool
        enabledRent
        companyName
        title
        schoolHeader
        rentHeader
        schoolClaim
        rentClaim
        rentVop
        schoolVop
        schoolBookingOffset
        schoolGroupBookingOffset
        schoolCampBookingOffset
        rentBookingOffsetHours
        rentBookingOffset
        checkoutTimeLimit
        showPriceWithoutDPH
        rentDiscountPercent
        schoolDiscountPercent
        email
        phone
        emailNotifLogoUrl
        websiteUrl
        webLogoUrl
        webLogoSmallUrl
        webHeroBgImgUrl
        productImageRatio
        paymentMethods
        currency
        cartStaticInfo
        checkoutStaticInfo
        introText
        emailText
        emailTextSchool
        emailTextRent
        lowSeasons {
          from
          to
          __typename
        }
        discountCodeImplementation
        generalTermsConditionsURL
        rentalSetsEnabled
        rentalDisplaySizesEnabled
        displayGeneralPrices
        displayPickUpDate
        schoolPointMeetingInfo
        schoolPointMeetingUrl
        schoolSkillLevelClientInfo
        schoolSkillLevelClientURL
        sganttSlotTimeLengthReductions {
          sganttSlotType
          defaultReduction
          reductions {
            timeLengthInHours
            reductionInMinutes
            __typename
          }
          __typename
        }
        mobRentIcon
        mobSchoolIcon
        locales
        defaultLocale
        courseLanguages
        courseGroupClientLanguages
        coursePrivateClientLanguages
        courseGroupIsWholeDayRequired
        rentSelectSizeAutomatic
        shoeSizeItems
        rentDisabledPointSells
        rentDatePickTryOutEnabled
        deliveryPoints
        rentProductCardImgHeightXs
        rentProductCardImgHeightSm
        rentProductCardImgHeightMd
        rentProductCardImgHeightLg
        rentProductCardImgHeightXl
        rentSearchSmCols
        rentSearchMdCols
        rentSearchLgCols
        rentProductCardImgAspectRatio
        useV2SchoolAvailability
        gaTrackingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMOBConfigsByAppInstance = /* GraphQL */ `
  query ListMOBConfigsByAppInstance(
    $appInstance: String
    $sortDirection: ModelSortDirection
    $filter: ModelMOBConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMOBConfigsByAppInstance(
      appInstance: $appInstance
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mobDeploymentId
        enabled
        enabledSchool
        enabledRent
        companyName
        title
        schoolHeader
        rentHeader
        schoolClaim
        rentClaim
        rentVop
        schoolVop
        schoolBookingOffset
        schoolGroupBookingOffset
        schoolCampBookingOffset
        rentBookingOffsetHours
        rentBookingOffset
        checkoutTimeLimit
        showPriceWithoutDPH
        rentDiscountPercent
        schoolDiscountPercent
        email
        phone
        emailNotifLogoUrl
        websiteUrl
        webLogoUrl
        webLogoSmallUrl
        webHeroBgImgUrl
        productImageRatio
        paymentMethods
        currency
        cartStaticInfo
        checkoutStaticInfo
        introText
        emailText
        emailTextSchool
        emailTextRent
        lowSeasons {
          from
          to
          __typename
        }
        discountCodeImplementation
        generalTermsConditionsURL
        rentalSetsEnabled
        rentalDisplaySizesEnabled
        displayGeneralPrices
        displayPickUpDate
        schoolPointMeetingInfo
        schoolPointMeetingUrl
        schoolSkillLevelClientInfo
        schoolSkillLevelClientURL
        sganttSlotTimeLengthReductions {
          sganttSlotType
          defaultReduction
          reductions {
            timeLengthInHours
            reductionInMinutes
            __typename
          }
          __typename
        }
        mobRentIcon
        mobSchoolIcon
        locales
        defaultLocale
        courseLanguages
        courseGroupClientLanguages
        coursePrivateClientLanguages
        courseGroupIsWholeDayRequired
        rentSelectSizeAutomatic
        shoeSizeItems
        rentDisabledPointSells
        rentDatePickTryOutEnabled
        deliveryPoints
        rentProductCardImgHeightXs
        rentProductCardImgHeightSm
        rentProductCardImgHeightMd
        rentProductCardImgHeightLg
        rentProductCardImgHeightXl
        rentSearchSmCols
        rentSearchMdCols
        rentSearchLgCols
        rentProductCardImgAspectRatio
        useV2SchoolAvailability
        gaTrackingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMOBConfigsByAppInstanceMobVersion = /* GraphQL */ `
  query ListMOBConfigsByAppInstanceMobVersion(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMOBConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMOBConfigsByAppInstanceMobVersion(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mobDeploymentId
        enabled
        enabledSchool
        enabledRent
        companyName
        title
        schoolHeader
        rentHeader
        schoolClaim
        rentClaim
        rentVop
        schoolVop
        schoolBookingOffset
        schoolGroupBookingOffset
        schoolCampBookingOffset
        rentBookingOffsetHours
        rentBookingOffset
        checkoutTimeLimit
        showPriceWithoutDPH
        rentDiscountPercent
        schoolDiscountPercent
        email
        phone
        emailNotifLogoUrl
        websiteUrl
        webLogoUrl
        webLogoSmallUrl
        webHeroBgImgUrl
        productImageRatio
        paymentMethods
        currency
        cartStaticInfo
        checkoutStaticInfo
        introText
        emailText
        emailTextSchool
        emailTextRent
        lowSeasons {
          from
          to
          __typename
        }
        discountCodeImplementation
        generalTermsConditionsURL
        rentalSetsEnabled
        rentalDisplaySizesEnabled
        displayGeneralPrices
        displayPickUpDate
        schoolPointMeetingInfo
        schoolPointMeetingUrl
        schoolSkillLevelClientInfo
        schoolSkillLevelClientURL
        sganttSlotTimeLengthReductions {
          sganttSlotType
          defaultReduction
          reductions {
            timeLengthInHours
            reductionInMinutes
            __typename
          }
          __typename
        }
        mobRentIcon
        mobSchoolIcon
        locales
        defaultLocale
        courseLanguages
        courseGroupClientLanguages
        coursePrivateClientLanguages
        courseGroupIsWholeDayRequired
        rentSelectSizeAutomatic
        shoeSizeItems
        rentDisabledPointSells
        rentDatePickTryOutEnabled
        deliveryPoints
        rentProductCardImgHeightXs
        rentProductCardImgHeightSm
        rentProductCardImgHeightMd
        rentProductCardImgHeightLg
        rentProductCardImgHeightXl
        rentSearchSmCols
        rentSearchMdCols
        rentSearchLgCols
        rentProductCardImgAspectRatio
        useV2SchoolAvailability
        gaTrackingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMOBConfigsByAppInstanceDeploymentId = /* GraphQL */ `
  query ListMOBConfigsByAppInstanceDeploymentId(
    $appInstance: String
    $mobDeploymentId: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMOBConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMOBConfigsByAppInstanceDeploymentId(
      appInstance: $appInstance
      mobDeploymentId: $mobDeploymentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mobDeploymentId
        enabled
        enabledSchool
        enabledRent
        companyName
        title
        schoolHeader
        rentHeader
        schoolClaim
        rentClaim
        rentVop
        schoolVop
        schoolBookingOffset
        schoolGroupBookingOffset
        schoolCampBookingOffset
        rentBookingOffsetHours
        rentBookingOffset
        checkoutTimeLimit
        showPriceWithoutDPH
        rentDiscountPercent
        schoolDiscountPercent
        email
        phone
        emailNotifLogoUrl
        websiteUrl
        webLogoUrl
        webLogoSmallUrl
        webHeroBgImgUrl
        productImageRatio
        paymentMethods
        currency
        cartStaticInfo
        checkoutStaticInfo
        introText
        emailText
        emailTextSchool
        emailTextRent
        lowSeasons {
          from
          to
          __typename
        }
        discountCodeImplementation
        generalTermsConditionsURL
        rentalSetsEnabled
        rentalDisplaySizesEnabled
        displayGeneralPrices
        displayPickUpDate
        schoolPointMeetingInfo
        schoolPointMeetingUrl
        schoolSkillLevelClientInfo
        schoolSkillLevelClientURL
        sganttSlotTimeLengthReductions {
          sganttSlotType
          defaultReduction
          reductions {
            timeLengthInHours
            reductionInMinutes
            __typename
          }
          __typename
        }
        mobRentIcon
        mobSchoolIcon
        locales
        defaultLocale
        courseLanguages
        courseGroupClientLanguages
        coursePrivateClientLanguages
        courseGroupIsWholeDayRequired
        rentSelectSizeAutomatic
        shoeSizeItems
        rentDisabledPointSells
        rentDatePickTryOutEnabled
        deliveryPoints
        rentProductCardImgHeightXs
        rentProductCardImgHeightSm
        rentProductCardImgHeightMd
        rentProductCardImgHeightLg
        rentProductCardImgHeightXl
        rentSearchSmCols
        rentSearchMdCols
        rentSearchLgCols
        rentProductCardImgAspectRatio
        useV2SchoolAvailability
        gaTrackingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStaticContent = /* GraphQL */ `
  query GetStaticContent($id: ID!) {
    getStaticContent(id: $id) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStaticContents = /* GraphQL */ `
  query ListStaticContents(
    $filter: ModelStaticContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaticContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        title
        icon
        isExternal
        linkUrl
        content
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStaticContentByAppInstance = /* GraphQL */ `
  query ListStaticContentByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStaticContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaticContentByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        title
        icon
        isExternal
        linkUrl
        content
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSkill = /* GraphQL */ `
  query GetSkill($id: ID!) {
    getSkill(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSkills = /* GraphQL */ `
  query ListSkills(
    $filter: ModelSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSkillsByAppInstance = /* GraphQL */ `
  query ListSkillsByAppInstance(
    $appInstance: String
    $sortDirection: ModelSortDirection
    $filter: ModelSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkillsByAppInstance(
      appInstance: $appInstance
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSkillLevelClient = /* GraphQL */ `
  query GetSkillLevelClient($id: ID!) {
    getSkillLevelClient(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      name
      description
      orderNumber
      codeSkillLevelClient
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSkillLevelClients = /* GraphQL */ `
  query ListSkillLevelClients(
    $filter: ModelSkillLevelClientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkillLevelClients(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSkillLevelClientsByAppInstance = /* GraphQL */ `
  query ListSkillLevelClientsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSkillLevelClientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkillLevelClientsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      intro
      description
      productType
      enabledFrom
      enabledTo
      pricingMode
      priceListType
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      alternativePriceLists {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      rentAllowedLengths {
        length
        unit
        __typename
      }
      schoolFormType
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      allowGroupCourseFlexibleStart
      groupCourseCustomLessonSelection
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      hidden
      campCourse
      textEmail
      customFormSchema
      createdAt
      updatedAt
      ageGroups {
        items {
          id
          productId
          ageGroupId
          createdAt
          updatedAt
          ageGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            ageFrom
            ageTo
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      skillLevelClients {
        items {
          id
          mobVersion
          groups
          appInstance
          productId
          skillLevelClientId
          length
          startTime
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      masterProduct {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      childProducts {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      productPackets {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProductsByAppInstance = /* GraphQL */ `
  query ListProductsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductPacket = /* GraphQL */ `
  query GetProductPacket($id: ID!) {
    getProductPacket(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      image
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          productPacketId
          productId
          orderNumber
          preselected
          required
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listProductPackets = /* GraphQL */ `
  query ListProductPackets(
    $filter: ModelProductPacketFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductPackets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProductPacketsByAppInstance = /* GraphQL */ `
  query ListProductPacketsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductPacketFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductPacketsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      campCourse
      hidden
      rentalSet
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCategorysByAppInstance = /* GraphQL */ `
  query ListCategorysByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategorysByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCategoriesByProductType = /* GraphQL */ `
  query ListCategoriesByProductType(
    $appInstance: String
    $mobVersionProductType: ModelCategoryListCategoriesByProductTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesByProductType(
      appInstance: $appInstance
      mobVersionProductType: $mobVersionProductType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLocationsByAppInstance = /* GraphQL */ `
  query ListLocationsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPointSell = /* GraphQL */ `
  query GetPointSell($id: ID!) {
    getPointSell(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      orderNumber
      email
      note
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listPointSells = /* GraphQL */ `
  query ListPointSells(
    $filter: ModelPointSellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSells(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPointSellsByAppInstance = /* GraphQL */ `
  query ListPointSellsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointSellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPointSellOpenHours = /* GraphQL */ `
  query GetPointSellOpenHours($id: ID!) {
    getPointSellOpenHours(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      pointSellMssId
      scheduleType
      dateFrom
      dateTo
      closedAllPeriod
      name
      scheduleScope
      scheduleSort
      createdAt
      updatedAt
      intervals {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          dayOfWeek
          intervalNo
          opens
          closes
          createdAt
          updatedAt
          openHours {
            id
            mobVersion
            groups
            appInstance
            mssId
            pointSellMssId
            scheduleType
            dateFrom
            dateTo
            closedAllPeriod
            name
            scheduleScope
            scheduleSort
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listPointSellOpenHours = /* GraphQL */ `
  query ListPointSellOpenHours(
    $filter: ModelPointSellOpenHoursFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellOpenHours(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        pointSellMssId
        scheduleType
        dateFrom
        dateTo
        closedAllPeriod
        name
        scheduleScope
        scheduleSort
        createdAt
        updatedAt
        intervals {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            dayOfWeek
            intervalNo
            opens
            closes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPointSellOpenHoursByScope = /* GraphQL */ `
  query ListPointSellOpenHoursByScope(
    $scheduleScope: String
    $scheduleSort: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointSellOpenHoursFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellOpenHoursByScope(
      scheduleScope: $scheduleScope
      scheduleSort: $scheduleSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        pointSellMssId
        scheduleType
        dateFrom
        dateTo
        closedAllPeriod
        name
        scheduleScope
        scheduleSort
        createdAt
        updatedAt
        intervals {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            dayOfWeek
            intervalNo
            opens
            closes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPointSellOpenHoursInterval = /* GraphQL */ `
  query GetPointSellOpenHoursInterval($id: ID!) {
    getPointSellOpenHoursInterval(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      dayOfWeek
      intervalNo
      opens
      closes
      createdAt
      updatedAt
      openHours {
        id
        mobVersion
        groups
        appInstance
        mssId
        pointSellMssId
        scheduleType
        dateFrom
        dateTo
        closedAllPeriod
        name
        scheduleScope
        scheduleSort
        createdAt
        updatedAt
        intervals {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            dayOfWeek
            intervalNo
            opens
            closes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listPointSellOpenHoursIntervals = /* GraphQL */ `
  query ListPointSellOpenHoursIntervals(
    $filter: ModelPointSellOpenHoursIntervalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellOpenHoursIntervals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        dayOfWeek
        intervalNo
        opens
        closes
        createdAt
        updatedAt
        openHours {
          id
          mobVersion
          groups
          appInstance
          mssId
          pointSellMssId
          scheduleType
          dateFrom
          dateTo
          closedAllPeriod
          name
          scheduleScope
          scheduleSort
          createdAt
          updatedAt
          intervals {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPointSellOpenHoursIntervalsByAppInstance = /* GraphQL */ `
  query ListPointSellOpenHoursIntervalsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointSellOpenHoursIntervalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellOpenHoursIntervalsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        dayOfWeek
        intervalNo
        opens
        closes
        createdAt
        updatedAt
        openHours {
          id
          mobVersion
          groups
          appInstance
          mssId
          pointSellMssId
          scheduleType
          dateFrom
          dateTo
          closedAllPeriod
          name
          scheduleScope
          scheduleSort
          createdAt
          updatedAt
          intervals {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductAvailabilityInterval = /* GraphQL */ `
  query GetProductAvailabilityInterval($id: ID!) {
    getProductAvailabilityInterval(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      productMssId
      productId
      name
      dateFrom
      dateTo
      availabilityPercent
      productScope
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductAvailabilityIntervals = /* GraphQL */ `
  query ListProductAvailabilityIntervals(
    $filter: ModelProductAvailabilityIntervalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductAvailabilityIntervals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        productMssId
        productId
        name
        dateFrom
        dateTo
        availabilityPercent
        productScope
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProductAvailabilityIntervalsByProduct = /* GraphQL */ `
  query ListProductAvailabilityIntervalsByProduct(
    $productScope: String
    $dateTo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductAvailabilityIntervalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductAvailabilityIntervalsByProduct(
      productScope: $productScope
      dateTo: $dateTo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        productMssId
        productId
        name
        dateFrom
        dateTo
        availabilityPercent
        productScope
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPointMeeting = /* GraphQL */ `
  query GetPointMeeting($id: ID!) {
    getPointMeeting(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      orderNumber
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          pointMeetingId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listPointMeetings = /* GraphQL */ `
  query ListPointMeetings(
    $filter: ModelPointMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointMeetings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPointMeetingsByAppInstance = /* GraphQL */ `
  query ListPointMeetingsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointMeetingsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSet = /* GraphQL */ `
  query GetSet($id: ID!) {
    getSet(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      categoryId
      title
      description
      priceTables {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      pricingMode
      createdAt
      updatedAt
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
        rentalSet
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          orderNumber
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSets = /* GraphQL */ `
  query ListSets(
    $filter: ModelSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSetsByAppInstance = /* GraphQL */ `
  query ListSetsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSetsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSetsByCategory = /* GraphQL */ `
  query ListSetsByCategory(
    $categoryId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSetsByCategory(
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubject = /* GraphQL */ `
  query GetSubject($id: ID!) {
    getSubject(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      age
      gender
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSubjects = /* GraphQL */ `
  query ListSubjects(
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSubjectsByAppInstance = /* GraphQL */ `
  query ListSubjectsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjectsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      expirationNotified
      createdAt
      updatedAt
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        mssOrderrId
        paymentMethod
        paymentState
        amount
        currency
        transId
        redirectUrl
        expirationNotified
        createdAt
        updatedAt
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPaymentsByAppInstance = /* GraphQL */ `
  query ListPaymentsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        mssOrderrId
        paymentMethod
        paymentState
        amount
        currency
        transId
        redirectUrl
        expirationNotified
        createdAt
        updatedAt
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPaymentsByPaymentState = /* GraphQL */ `
  query ListPaymentsByPaymentState(
    $paymentState: PaymentState
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByPaymentState(
      paymentState: $paymentState
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        mssOrderrId
        paymentMethod
        paymentState
        amount
        currency
        transId
        redirectUrl
        expirationNotified
        createdAt
        updatedAt
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPaymentByTransId = /* GraphQL */ `
  query GetPaymentByTransId(
    $transId: String
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getPaymentByTransId(
      transId: $transId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        mssOrderrId
        paymentMethod
        paymentState
        amount
        currency
        transId
        redirectUrl
        expirationNotified
        createdAt
        updatedAt
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderr = /* GraphQL */ `
  query GetOrderr($id: ID!) {
    getOrderr(id: $id) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      discountCode
      language
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        age
        gender
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          expirationNotified
          createdAt
          updatedAt
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listOrderrs = /* GraphQL */ `
  query ListOrderrs(
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrderrsByAppInstance = /* GraphQL */ `
  query ListOrderrsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrderrsByBookingState = /* GraphQL */ `
  query ListOrderrsByBookingState(
    $appInstance: String
    $mobVersionBookingState: ModelOrderrListOrderrsByBookingStateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrsByBookingState(
      appInstance: $appInstance
      mobVersionBookingState: $mobVersionBookingState
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrderrsByBookingStateAndExpireAt = /* GraphQL */ `
  query ListOrderrsByBookingStateAndExpireAt(
    $bookingState: BookingState
    $expireAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrsByBookingStateAndExpireAt(
      bookingState: $bookingState
      expireAt: $expireAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderrItemGroup = /* GraphQL */ `
  query GetOrderrItemGroup($id: ID!) {
    getOrderrItemGroup(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfiles {
        name
        surname
        weight
        height
        shoeSize
        age
        birthDate
        gender
        rentAbilityLevel
        schoolSkillLevelClientId
        note
        language
        customFormData
        __typename
      }
      description
      orderrItemGroupPointSellId
      itemsCount
      numberOfPersons
      length
      priceListType
      alternativePriceTable {
        mssId
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
        __typename
      }
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      productPacket {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        image
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        orderNumber
        email
        note
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        categoryId
        title
        description
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        pricingMode
        createdAt
        updatedAt
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        discountCode
        language
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          age
          gender
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            expirationNotified
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          article {
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            __typename
          }
          language
          languages
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
            __typename
          }
          groupCourse {
            id
            mobVersion
            appInstance
            mssId
            title
            description
            pointMeetingMssId
            dateFrom
            dateTo
            availableCapacity
            hoursPerDay
            minLength
            skillLevelClientId
            allowGroupCourseFlexibleStart
            price
            __typename
          }
          groupCourseDateStart
          groupCourseLessons {
            id
            mobVersion
            appInstance
            mssId
            timeFrom
            timeTo
            availableCapacity
            __typename
          }
          price
          priceWithoutDph
          dph
          dphPercent
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          priceListType
          createdAt
          updatedAt
          skillLevelClient {
            id
            mobVersion
            groups
            appInstance
            mssId
            name
            description
            orderNumber
            codeSkillLevelClient
            createdAt
            updatedAt
            __typename
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listOrderrItemGroups = /* GraphQL */ `
  query ListOrderrItemGroups(
    $filter: ModelOrderrItemGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItemGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfiles {
          name
          surname
          weight
          height
          shoeSize
          age
          birthDate
          gender
          rentAbilityLevel
          schoolSkillLevelClientId
          note
          language
          customFormData
          __typename
        }
        description
        orderrItemGroupPointSellId
        itemsCount
        numberOfPersons
        length
        priceListType
        alternativePriceTable {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        productPacket {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          image
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrderrItemGroupsByAppInstance = /* GraphQL */ `
  query ListOrderrItemGroupsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrItemGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItemGroupsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfiles {
          name
          surname
          weight
          height
          shoeSize
          age
          birthDate
          gender
          rentAbilityLevel
          schoolSkillLevelClientId
          note
          language
          customFormData
          __typename
        }
        description
        orderrItemGroupPointSellId
        itemsCount
        numberOfPersons
        length
        priceListType
        alternativePriceTable {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        productPacket {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          image
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderrItem = /* GraphQL */ `
  query GetOrderrItem($id: ID!) {
    getOrderrItem(id: $id) {
      id
      mobVersion
      groups
      appInstance
      article {
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        __typename
      }
      language
      languages
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
        __typename
      }
      groupCourse {
        id
        mobVersion
        appInstance
        mssId
        title
        description
        pointMeetingMssId
        dateFrom
        dateTo
        availableCapacity
        hoursPerDay
        minLength
        skillLevelClientId
        allowGroupCourseFlexibleStart
        price
        __typename
      }
      groupCourseDateStart
      groupCourseLessons {
        id
        mobVersion
        appInstance
        mssId
        timeFrom
        timeTo
        availableCapacity
        __typename
      }
      price
      priceWithoutDph
      dph
      dphPercent
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      priceListType
      createdAt
      updatedAt
      skillLevelClient {
        id
        mobVersion
        groups
        appInstance
        mssId
        name
        description
        orderNumber
        codeSkillLevelClient
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        intro
        description
        productType
        enabledFrom
        enabledTo
        pricingMode
        priceListType
        priceTables {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        alternativePriceLists {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        rentAllowedLengths {
          length
          unit
          __typename
        }
        schoolFormType
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        allowGroupCourseFlexibleStart
        groupCourseCustomLessonSelection
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        hidden
        campCourse
        textEmail
        customFormSchema
        createdAt
        updatedAt
        ageGroups {
          items {
            id
            productId
            ageGroupId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          __typename
        }
        skillLevelClients {
          items {
            id
            mobVersion
            groups
            appInstance
            productId
            skillLevelClientId
            length
            startTime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        masterProduct {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          campCourse
          hidden
          rentalSet
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            pointMeetingId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        productPackets {
          items {
            id
            mobVersion
            groups
            appInstance
            productPacketId
            productId
            orderNumber
            preselected
            required
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            orderrItemGroupPointSellId
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfiles {
          name
          surname
          weight
          height
          shoeSize
          age
          birthDate
          gender
          rentAbilityLevel
          schoolSkillLevelClientId
          note
          language
          customFormData
          __typename
        }
        description
        orderrItemGroupPointSellId
        itemsCount
        numberOfPersons
        length
        priceListType
        alternativePriceTable {
          mssId
          numberOfPersons
          priceListType
          isLowSeason
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
          __typename
        }
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        productPacket {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          image
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          pointSells {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          orderNumber
          email
          note
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          orderrs {
            nextToken
            __typename
          }
          __typename
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          categoryId
          title
          description
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          pricingMode
          createdAt
          updatedAt
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          products {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          discountCode
          language
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            age
            gender
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            __typename
          }
          payments {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          __typename
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            languages
            sameInstructorRequired
            numberOfHoursRequired
            groupCourseDateStart
            price
            priceWithoutDph
            dph
            dphPercent
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            priceListType
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listOrderrItems = /* GraphQL */ `
  query ListOrderrItems(
    $filter: ModelOrderrItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        article {
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          __typename
        }
        language
        languages
        sameInstructorRequired
        numberOfHoursRequired
        lessons {
          mobVersion
          groups
          appInstance
          mssId
          timeFrom
          timeTo
          timeLength
          mssWorkDayId
          __typename
        }
        groupCourse {
          id
          mobVersion
          appInstance
          mssId
          title
          description
          pointMeetingMssId
          dateFrom
          dateTo
          availableCapacity
          hoursPerDay
          minLength
          skillLevelClientId
          allowGroupCourseFlexibleStart
          price
          __typename
        }
        groupCourseDateStart
        groupCourseLessons {
          id
          mobVersion
          appInstance
          mssId
          timeFrom
          timeTo
          availableCapacity
          __typename
        }
        price
        priceWithoutDph
        dph
        dphPercent
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        priceListType
        createdAt
        updatedAt
        skillLevelClient {
          id
          mobVersion
          groups
          appInstance
          mssId
          name
          description
          orderNumber
          codeSkillLevelClient
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        orderrItemGroup {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrderrItemsByAppInstance = /* GraphQL */ `
  query ListOrderrItemsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItemsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        article {
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          __typename
        }
        language
        languages
        sameInstructorRequired
        numberOfHoursRequired
        lessons {
          mobVersion
          groups
          appInstance
          mssId
          timeFrom
          timeTo
          timeLength
          mssWorkDayId
          __typename
        }
        groupCourse {
          id
          mobVersion
          appInstance
          mssId
          title
          description
          pointMeetingMssId
          dateFrom
          dateTo
          availableCapacity
          hoursPerDay
          minLength
          skillLevelClientId
          allowGroupCourseFlexibleStart
          price
          __typename
        }
        groupCourseDateStart
        groupCourseLessons {
          id
          mobVersion
          appInstance
          mssId
          timeFrom
          timeTo
          availableCapacity
          __typename
        }
        price
        priceWithoutDph
        dph
        dphPercent
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        priceListType
        createdAt
        updatedAt
        skillLevelClient {
          id
          mobVersion
          groups
          appInstance
          mssId
          name
          description
          orderNumber
          codeSkillLevelClient
          createdAt
          updatedAt
          products {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          intro
          description
          productType
          enabledFrom
          enabledTo
          pricingMode
          priceListType
          priceTables {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          alternativePriceLists {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          rentAllowedLengths {
            length
            unit
            __typename
          }
          schoolFormType
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          allowGroupCourseFlexibleStart
          groupCourseCustomLessonSelection
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          hidden
          campCourse
          textEmail
          customFormSchema
          createdAt
          updatedAt
          ageGroups {
            nextToken
            __typename
          }
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
            __typename
          }
          skillLevelClients {
            nextToken
            __typename
          }
          masterProduct {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          childProducts {
            nextToken
            __typename
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            campCourse
            hidden
            rentalSet
            createdAt
            updatedAt
            __typename
          }
          locations {
            nextToken
            __typename
          }
          pointMeetings {
            nextToken
            __typename
          }
          sets {
            nextToken
            __typename
          }
          productPackets {
            nextToken
            __typename
          }
          orderrItemGroups {
            nextToken
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        orderrItemGroup {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfiles {
            name
            surname
            weight
            height
            shoeSize
            age
            birthDate
            gender
            rentAbilityLevel
            schoolSkillLevelClientId
            note
            language
            customFormData
            __typename
          }
          description
          orderrItemGroupPointSellId
          itemsCount
          numberOfPersons
          length
          priceListType
          alternativePriceTable {
            mssId
            numberOfPersons
            priceListType
            isLowSeason
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
            __typename
          }
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            intro
            description
            productType
            enabledFrom
            enabledTo
            pricingMode
            priceListType
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            hidden
            campCourse
            textEmail
            customFormSchema
            createdAt
            updatedAt
            __typename
          }
          productPacket {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            image
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            orderNumber
            email
            note
            createdAt
            updatedAt
            __typename
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
            __typename
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            categoryId
            title
            description
            pricingMode
            createdAt
            updatedAt
            __typename
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            discountCode
            language
            createdAt
            updatedAt
            __typename
          }
          orderrItems {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
